import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: Wrap;
  justify-content: space-between;
  margin: 32px 0 16px;
  width: 100%;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-bottom: 16px;
  width: 45%;

  & label {
    color: rgba(255, 255, 255, 0.5);
    margin-bottom: 8px;
    font-size: 14px;
  }

  & input {
    border: 1px solid white;
    background-color: transparent;
    font-size: 16px;
    padding: 5px 8px;
    color: #fff;
    border-radius: 10px;
    height: 28px;
  }
`;
